export default __webpack_public_path__ + "static/media/FARMING_AGRICULTURE.f297be6a.png";